var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSelectArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 12,
  viewBox: "0 0 8 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.519 4.633 4.162 2.276 1.805 4.633a.667.667 0 0 1-.943-.943L3.69.862c.26-.26.683-.26.943 0L7.461 3.69a.667.667 0 1 1-.942.943Zm0 3.057-2.357 2.357L1.805 7.69a.667.667 0 0 0-.943.943l2.828 2.829c.26.26.683.26.943 0l2.828-2.829a.667.667 0 1 0-.942-.943Z",
  fill: "#000"
})));
export { SvgSelectArrow as ReactComponent };